<template>
  <div>
    <el-card>
      <el-button type="goon" @click="onClickAppear()">去上报</el-button>

      <el-button type="goon" @click="dialogVisibleImport = true"
        >批量导入多日食材</el-button
      >
      <el-button type="goon" @click="onStudentExeal">模版下载</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column
          align="center"
          prop="ReportDateString"
          label="计划食材日期"
        ></el-table-column>
        <el-table-column
          prop="Reporter"
          align="center"
          label="计划人"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onEditData(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="onClickDelete(scope.row)"
              style="color: #e14747"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog title="导入" :visible.sync="dialogVisibleImport">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        list-type="excel"
        :show-file-list="true"
        :drag="true"
        action
        :limit="1"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetHe_FoodEverydayListNext,
  FileUploadsExcel,
  ImportHe_FoodEveryDayNext,
  DelHe_FoodEveryDay,
} from "../../../api/api";

export default {
  data() {
    return {
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      userInfo: {},
      dialogVisibleImport: false,
      excelurl: "",
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetHe_FoodEverydayListNext();
  },
  methods: {
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetHe_FoodEverydayListNext();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetHe_FoodEverydayListNext();
    },
    onEditData(item) {
      //console.log(item, "aaa");
      this.$router.push({
        path: "/Fitness/DataEntry/nextWeek_add",
        query: {
          Id: item.Id,
          ReportDateString: item.ReportDateString,
        },
      });
    },
    onClickDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelHe_FoodEveryDay({ ids: [row.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetHe_FoodEverydayListNext();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    onStudentExeal() {
      location.href =
        "http://www.mushroomisland.cn/exceldown/%E8%98%91%E8%8F%87%E5%B2%9BV3%E6%AF%8F%E6%97%A5%E9%A3%9F%E6%9D%90%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
    },
    //上传文件
    ImportStudent() {
      if (this.excelurl) {
        ImportHe_FoodEveryDayNext({
          fileName: this.excelurl,
          Uid: this.userInfo.uID,
          SchoolId: this.userInfo.SchoolId,
          UserName: this.userInfo.uRealName,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleImport = false;
            this.GetHe_FoodEverydayListNext();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //导入
    uploadFile(item) {
      //console.log(item);
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        this.excelurl = res.data.url;
        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    async GetHe_FoodEverydayListNext() {
      const params = {
        Id: this.userInfo.SchoolId,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      let res = await GetHe_FoodEverydayListNext(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    onClickAppear() {
      this.$router.push({
        path: "/Fitness/DataEntry/nextWeek_add",
        query: {
          Id: 0,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.mg-right {
  margin-right: 20px;
}
.mg-bottom {
  margin-bottom: 10px;
}
.tui-food {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
</style>